// extracted by mini-css-extract-plugin
export default {"text":"PromoModal_text__mB8jk","button":"PromoModal_button__ZLg+4"};